export default __webpack_public_path__ + "static/media/tip1.04ce803c.png";